import always from "./always";

// * -> null
const stubNull = always(null);

export default stubNull;
